import { render, staticRenderFns } from "./UserAccountView.vue?vue&type=template&id=ba1995d8"
import script from "./UserAccountView.vue?vue&type=script&lang=js"
export * from "./UserAccountView.vue?vue&type=script&lang=js"
import style0 from "./UserAccountView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports